import React from 'react'
import { Image } from 'react-bootstrap'

const EmailImage = () => {
  return (
    <>
        <div className="login-image-holder d-xl-block d-lg-block d-md-none d-none">
          <div className="d-flex justify-content-end align-items-center">
            <div className="pe-3 opacity-0">
              <Image src="/assets/images/DIDI.svg"/>
            </div>
          </div>
          <div className="pb-5 position-relative  px-4">
          <Image src="/assets/images/email-img.png" className="m-auto d-flex login-reset-img"/>
             <div className="develop-assets-img assets-img">
                <p className="font-16 font-weight-medium">Forgot Password</p>
              </div>
          </div>
        </div>                                             
    </>
  )
}

export default EmailImage
